<template>
  <div class="playvid-container p-3 pb-6 relative text-[#7F8083] bg-[#f7f8fb]">
    <div class="text-[#7F8083] text-13 font-semibold leading-16 pb-1 u-center">
      {{ $t('news-page.article-ad-title') }}
      <OIcon icon="chevron-right-grey" class="rotate-90 ml-1.5" />
    </div>
    <div ref="el"></div>
    <div class="absolute right-1 bottom-1 flex justify-end text-xs text-primary-200">{{ $t('main.ads') }}</div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from '@nuxtjs/composition-api';
import OIcon from '~/modules/common/components/ui/OIcon/OIcon';

export default defineComponent({
  components: {
    OIcon,
  },
  setup() {
    const el = ref();
    onMounted(() => {
      if (el.value) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://360playvid.info/slidepleer/s02565s.js';
        script.type = 'text/javascript';
        el.value.appendChild(script);
      }
    });

    return { el };
  },
});
</script>
